import "./Controls.scss";
import { CloseIcon } from "../../Common/Icons";

function SearchResponseControls({ onClose, options }) {
  const config = Object.entries(options)
    // ignore undefined
    .filter(([option, value]) => value !== undefined)
    // merge options with default
    .reduce(
      (obj, [option, value]) => {
        obj[option] = value;
        return obj;
      },
      {
        response_close_label: <span>Fechar</span>,
      }
    );

  return (
    <div className="bn-search__response-controls">
      <button type="button" className="bn-close" onClick={onClose}>
        {config.response_close_label}
        <CloseIcon />
      </button>
    </div>
  );
}

export default SearchResponseControls;
